<template>
  <DModal
    :show-close="false"
    :isBgOverlay="true"
    @close="$emit('close')"
    :appendToBody="true"
    style="z-index: 12312312312312"
  >
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2 v-if="isEditing">Redigér ansættelsesskabelon</h2>
        <h2 v-else>Opret ny ansættelsesskabelon</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="d-input-group">
          <label class="d-label">Titel</label>
          <input
            type="text"
            class="d-input"
            v-model="title"
            ref="input_title"
            placeholder="F.eks. Lærervikar"
          >
        </div>

        <div
          class="d-input-group d-input-group--toggler"
          :class="{'d-input-group--toggler--active': localManualSalary}"
          @click.stop="setIsManualSalary(!localManualSalary)"
        >
          <label class="d-label">Skal indberettes som vikarløn</label>
          <AppToggle :allowChanges="false" :propOn="localManualSalary"/>
        </div>

        <!-- Vises kun når vikarløn er slået til -->
        <div class="d-input-group-flex" v-if="localManualSalary">
          <div>
            <label class="d-label">Standard lønkode</label>
            <select class="do-select width-100" v-model="salaryCodeId">
              <option disabled value=""></option>
              <option
                v-for="salaryCode in salaryCodes"
                :key="salaryCode.id"
                :value="salaryCode.id"
              >
                {{ salaryCode.name }} ({{ salaryCode.code }})
              </option>
            </select>
          </div>

          <div v-if="costCenters.length > 0">
            <label class="d-label">Standard omkostningsted</label>
            <select class="do-select width-100" v-model="omkostningssted">
              <option disabled value=""></option>
              <option v-for="costCenter in costCenters" :key="costCenter.code" :value="costCenter.code">
                {{ costCenter.title }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="d-modal__buttons">
        <div>
          <button
            v-if="isEditing"
            class="do-bttn"
            :class="{'do-bttn--submit--loading': isDeleting}"
            @click="deleteEmploymentTemplate"
          >
            <span class="icon-bin"></span>
          </button>
        </div>
        <div>
          <button class="do-bttn" @click="$emit('close')">
            {{ $t('vue2.common.cancel') }}
          </button>
          <button
            class="do-bttn do-bttn--submit"
            :class="{
              'do-bttn--submit--disabled': !isValid || isSubmitting,
              'do-bttn--submit--loading': isSubmitting
            }"
            @click="onSubmit"
          >
            {{ isEditing ? 'Opdatér' : 'Opret' }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import AppToggle from '../../common/AppToggle.vue'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'

export default {
  components: {AppToggle, DModal},
  props: {
    theEditEmploymentTemplate: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      title: '',
      localManualSalary: false,
      salaryCodeId: '',
      omkostningssted: '',
      isSubmitting: false,
      isDeleting: false
    }
  },
  computed: {
    isEditing () {
      return !!this.theEditEmploymentTemplate
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    templateId () {
      return this.isEditing ? this.theEditEmploymentTemplate.id : null
    },
    isValid () {
      return this.title.trim().length > 0
    },
    costCenters () {
      return this.$store.getters.costCenters
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted
    },
    supplementTypes () {
      // forventet shape:
      // [{ title, code, loenart, loebenummer }, ...]
      return this.$store.getters.supplementTypesSorted
    }
  },
  methods: {
    setIsManualSalary (bool) {
      this.localManualSalary = bool
      if (!bool) {
        this.resetManualFields()
      }
    },
    resetManualFields () {
      this.salaryCodeId = ''
      this.omkostningssted = ''
    },
    onSubmit () {
      if (!this.isValid || this.isSubmitting) return

      this.isSubmitting = true

      const onSuccess = (response) => {
        this.isSubmitting = false
        if (response.status === 'error') {
          eventbus.toast = {text: response.message, 'success': false}
          return
        }
        if (this.isEditing) {
          this.$emit('updated', response)
        } else {
          this.$emit('created', response)
        }
        this.$emit('close')
      }

      const onFailure = () => {
        this.isSubmitting = false
      }

      if (this.isEditing) {
        docendo.updateEmploymentTemplate(
          this.schoolId,
          this.templateId,
          this.title.trim(),
          this.localManualSalary,
          this.salaryCodeId * 1,
          this.omkostningssted * 1,
          onSuccess,
          onFailure
        )
      } else {
        docendo.createEmploymentTemplate(
          this.schoolId,
          this.title.trim(),
          this.localManualSalary,
          this.salaryCodeId,
          this.omkostningssted,
          onSuccess,
          onFailure
        )
      }
    },

    deleteEmploymentTemplate () {
      if (!this.isEditing || this.isDeleting) return
      this.isDeleting = true

      const onSuccess = (response) => {
        if (response.status === 'error') {
          eventbus.toast = {text: response.message, 'success': false}
        }
        this.isDeleting = false
        this.$emit('deleted', response)
        this.$emit('close')
      }

      const onFailure = (error) => {
        this.isDeleting = false
        console.log('deleteEmploymentTemplate failed', error)
      }

      docendo.deleteEmploymentTemplate(
        this.schoolId,
        this.templateId,
        onSuccess,
        onFailure
      )
    }
  },
  beforeMount () {
    if (this.theEditEmploymentTemplate) {
      const t = this.theEditEmploymentTemplate
      this.title = t.title || ''
      this.salaryCodeId = typeof t.salary_code_id !== 'undefined' && t.salary_code_id !== null ? String(t.salary_code_id) : ''
      this.omkostningssted = typeof t.omkostningssted !== 'undefined' && t.omkostningssted !== null ? String(t.omkostningssted) : ''
      this.localManualSalary = !!t.manual_salary
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const el = this.$refs.input_title
      if (el) el.focus()
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 500px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 1rem;
}

.d-input-group-flex {
  display: flex;
  padding: 0 1rem;
  gap: 1rem;
}

.d-input-group-flex > div {
  flex: 1;
}

.d-input-group-flex label.d-label {
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// DoEmploymentTemplate.vue?2aa43edc